import { IHelpCenterCategory } from '@sv-support-sdk/shared-types/src/common/helpCenter'

import { IBreadcrumb } from '../components/Navigation/Breadcrumbs';
import { routes } from '../routing';
import { $l } from '../locales';

type TCategory = IHelpCenterCategory | null | undefined;

const getCategoryById = (categories: IHelpCenterCategory[], categoryId?: number) =>
  categories.find(({ id }) => id === categoryId);

const buildCategoriesChain = (categories: IHelpCenterCategory[], category: IHelpCenterCategory): TCategory[] => {
  if (category.parentId === null) {
    return [category];
  }

  const upperCategory = getCategoryById(categories, category.parentId);

  if (upperCategory?.parentId === null) {
    return [upperCategory, category];
  } else {
    const categoryById = getCategoryById(categories, upperCategory?.parentId);

    if (!categoryById) {
      return [upperCategory, category];
    }

    return [
      ...buildCategoriesChain(categories, categoryById),
      upperCategory,
      category,
    ];
  }
};

const createBreadcrumbs = ({
  categories,
  category,
  isLastDisabled,
}: {
  categories: IHelpCenterCategory[];
  category: IHelpCenterCategory;
  isLastDisabled?: boolean;
}) => {
  let breadcrumbs: IBreadcrumb[] = [
    {
      text: $l('BREADCRUMBS.GUIDES'),
      link: routes.articles,
    },
  ];

  const categoriesChain = buildCategoriesChain(categories, category);

  categoriesChain.forEach((category: TCategory, idx) => {
    if (!category) return;

    const categoryAsBreadcrumbOption = {
      text: category.name,
      link:
        isLastDisabled && !categoriesChain[idx + 1]
          ? ''
          : `${routes.articles}/${category.slug}`,
      isLast: isLastDisabled && !categoriesChain[idx + 1],
    };

    breadcrumbs.push(categoryAsBreadcrumbOption);
  });

  return breadcrumbs;
};

export { createBreadcrumbs };
